// モジュール呼び出し
import PlayController from '../lib/PlayController';
import Season from '../lib/Season';

/**
 * Recommended Placesの背景画像
 */
export default function v1ItineraryHero(elm) {
  let $target = elm;
  const movieParent = document.querySelector('.v1-itineraryHero__movie');
  const isSeasonalPage = Season.isSeasonalPage();

  // 季節出しわけの対象の場合は、属性値を変更する。
  if (isSeasonalPage) {
    const season = Season.is();
    const rootElement = document.querySelector('.v1-itinerary');
    rootElement.classList.add(`-${season}`);

    // インスタンス化する動画を上書きする。
    $target = document.querySelector(`.v1-itineraryHero__movieItem.-${season} video`);
    // インスタンス化しない(seasonが一致しない)動画のIDを削除する
    Array.from(movieParent.children).forEach(divEle => {
      let isRemove = true;
      Array.from(divEle.classList).forEach(className => {
        if (className === `-${season}`) {
          isRemove = false;
        }
      });
      if (isRemove) {
        movieParent.removeChild(divEle);
      }
    });

    const galleryImages = document.querySelectorAll('.v1-itinerarySpot__gallery-image');
    const thumbnailImages = document.querySelectorAll('.v1-itinerarySpot__thumbnail-image');

    Array.from(galleryImages).forEach(image => {
      const srcAttribute = image.getAttribute('data-src');
      image.setAttribute('data-src', srcAttribute.replace('spring', season));
    });
    Array.from(thumbnailImages).forEach(image => {
      const srcAttribute = image.getAttribute('data-src');
      image.setAttribute('data-src', srcAttribute.replace('spring', season));
    });

    const findOutMoreImages = document.querySelectorAll('.v1-kansaiByRailFindOutMore__img');

    if (findOutMoreImages) {
      Array.from(findOutMoreImages).forEach(image => {
        const srcAttribute = image.getAttribute('src');
        image.setAttribute('src', srcAttribute.replace('spring', season));
      });
    }
  }

  $target.setAttribute('aria-busy', 'true');
  // ロード完了時の挙動
  const actLoadstart = () => {
    movieParent.setAttribute('aria-busy', 'false');
    $target.setAttribute('aria-busy', 'false');
  };
  $target.addEventListener('loadeddata', actLoadstart, false);
  const movieControll = PlayController(
    $target,
    {
      button: document.getElementById('v1-itineraryHero__play'),
      callback: target => {
        target.play(); // 再生
      },
    },
    {
      button: document.getElementById('v1-itineraryHero__stop'),
      callback: target => {
        target.pause(); // 一時停止
      },
    },
  );
  movieControll.init();
}
